import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cleanHtml } from "../../lib/sanitize";

// Accessible FAQ accordion. FAQPage JSON-LD is emitted server-side (only when
// enabled FAQs exist), so this component just renders the visible, matching UI.
export default function FaqAccordion({ faqs = [], title = "Frequently Asked Questions" }) {
  const [open, setOpen] = useState(null);
  if (!faqs || faqs.length === 0) return null;

  return (
    <section className="mt-12" aria-labelledby="faq-heading" data-testid="faq-accordion">
      <h2 id="faq-heading" className="font-playfair text-2xl sm:text-3xl text-white mb-6">{title}</h2>
      <div className="divide-y divide-white/10 border-y border-white/10">
        {faqs.map((f, i) => {
          const isOpen = open === i;
          return (
            <div key={i} data-testid={`faq-item-${i}`}>
              <h3 className="m-0">
                <button
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={`faq-panel-${i}`}
                  id={`faq-trigger-${i}`}
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 py-5 text-left group focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/60 rounded"
                  data-testid={`faq-question-${i}`}
                >
                  <span className="text-white/90 group-hover:text-gold transition-colors text-base font-medium">{f.question}</span>
                  <ChevronDown className={`h-5 w-5 text-gold shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" />
                </button>
              </h3>
              <div
                id={`faq-panel-${i}`}
                role="region"
                aria-labelledby={`faq-trigger-${i}`}
                hidden={!isOpen}
                className="pb-5 -mt-1"
              >
                <div className="cf-rich prose prose-invert max-w-none text-white/70" dangerouslySetInnerHTML={{ __html: cleanHtml(f.answer) }} />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
